import { createMainResourceREST } from '../resource';
import {
  ChargeableSceneActions,
  ChargeableSceneState,
  CRChargeableSceneBody,
  CRChargeableSceneBodyAPI,
  CRChargeableSceneKey,
} from './types';

type AnyChargeableScene =
  | CRChargeableSceneKey
  | CRChargeableSceneBody
  | undefined;

function getEndpointChargeableScene(key: AnyChargeableScene): string {
  return `/chargeables/${key!.chargeableId}/scene`;
}

function sameChargeableScene(
  a: AnyChargeableScene,
  b: AnyChargeableScene,
): boolean {
  return a?.chargeableId === b?.chargeableId;
}

function mergeChargeableScene(
  last: CRChargeableSceneBody,
  current: CRChargeableSceneBody,
  isUpdate: boolean,
  lastSeqNum?: number,
  curSeqNum?: number,
) {
  if (!isUpdate && last.scene && current.scene && curSeqNum === lastSeqNum) {
    // parsing the scene and updating the WebGL model is expensive.
    // Avoid doing so when the scene itself hasn't changed (i.e. lockNum is the same)
    return {
      ...current,
      scene: last.scene,
    };
  }

  return current;
}

function mergeSummaryBody(
  oldSummary?: CRChargeableSceneBody,
  curBody?: CRChargeableSceneBody,
): CRChargeableSceneBody {
  return (curBody ?? oldSummary)!;
}

function parseChargeableScene(
  scene: CRChargeableSceneBodyAPI,
): CRChargeableSceneBody {
  return scene;
}

const chargeableSceneStateSelector = (state: any): ChargeableSceneState =>
  state.chargeableScene;

const { actions, reducer, watches } = createMainResourceREST(
  'chargeable-scene',
  getEndpointChargeableScene,
  chargeableSceneStateSelector,
  sameChargeableScene,
  parseChargeableScene,
  parseChargeableScene,
  mergeChargeableScene,
  mergeSummaryBody,
);

const chargeableSceneActions: ChargeableSceneActions = actions;
export {
  chargeableSceneActions,
  reducer as chargeableSceneReducer,
  watches as chargeableSceneWatches,
};

export * from './types';
